import { render, staticRenderFns } from "./OtpVerification.vue?vue&type=template&id=741ad7e6&scoped=true&"
import script from "./OtpVerification.vue?vue&type=script&lang=js&"
export * from "./OtpVerification.vue?vue&type=script&lang=js&"
import style0 from "./OtpVerification.vue?vue&type=style&index=0&id=741ad7e6&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741ad7e6",
  null
  
)

/* custom blocks */
import block0 from "./OtpVerification.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('741ad7e6')) {
      api.createRecord('741ad7e6', component.options)
    } else {
      api.reload('741ad7e6', component.options)
    }
    module.hot.accept("./OtpVerification.vue?vue&type=template&id=741ad7e6&scoped=true&", function () {
      api.rerender('741ad7e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OtpVerification.vue"
export default component.exports